/**
 * add-group-dialog.js
 */

import React from 'react';
import { Typography, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Dialog from 'components/dialog';
import FeatureBox from 'components/feature-box';


const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDialogContent-root': {
      paddingTop: theme.spacing(3),
    },
    '& .MuiDialogActions-root strong': {
      display: 'flex'
    },
  },
  text: {
    marginBottom: theme.spacing(3),
  }
}));


export const GROUP_ADD_TYPE = {
  MANAGER_SUPERVISOR: {
    id: 'manager-supervisor',
    title: 'Request Supervisor',
  },
  MANAGER_TRAINER: {
    id: 'manager-trainer',
    title: 'Request Trainer',
  },
  TRAINING_CODE: {
    id: 'training-code',
    title: 'Request To Join A Group',
  }
};


export default function AddGroupDialog(props) {
  const {
    isOpen,
    onClose,
    onOk,
    title,
    text,
    inputLabel,
  } = props;
  const classes = useStyles();
  const [inputText, setInputText] = React.useState('');
  const inputRef = React.useRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState();


  React.useEffect(() => {
    if (isOpen) {
      setInputText('');
      setError();
      setTimeout(() => inputRef.current?.focus());
    }
  }, [isOpen]);


  const tryOk = async () => {
    setIsLoading(true);
    const ret = await onOk(inputText);
    if (ret !== true) {
      setError(ret);
    }    
    setIsLoading(false);
  }


  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      tryOk();
    }
  }


  return (
    <>
      <Dialog
        fullWidth
        maxWidth='xs'
        title={title}
        className={classes.root}
        open={isOpen}
        onClose={onClose}
        okDisabled={isLoading}
        onOk={tryOk}
        contentWrap={<FeatureBox loading={isLoading} />}
        children={<>
          {text && <Typography className={classes.text}>{text}</Typography>}
          <TextField
            fullWidth
            inputRef={inputRef}
            label={inputLabel}
            variant='outlined'
            value={inputText}
            helperText={error}
            error={Boolean(error)}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={onKeyDown}
          />
        </>}
      />
    </>
  );
}